import React from "react";

const DashboardSkeleton: React.FC = () => {
  return (
    <div className="space-y-4">
      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {[...Array(6)].map((_, index) => (
          <div
            className="flex flex-col p-4 rounded-lg border border-gray-200 dark:border-neutral-700 justify-between h-[150px]"
            key={index}
          >
            <div className="flex items-start justify-between gap-3">
              <div className="flex-1">
                <div className="w-40 h-4 rounded bg-gray-200 dark:bg-neutral-700 animate-pulse"></div>
                <div className="w-32 h-8 rounded bg-gray-200 dark:bg-neutral-700 animate-pulse mt-2"></div>
              </div>
              <div className="w-12 h-12 rounded-full bg-gray-200 dark:bg-neutral-700 animate-pulse"></div>
            </div>

            <div className="pt-3 mt-3 border-t border-gray-100 dark:border-neutral-700">
              <div className="grid grid-cols-3 gap-4">
                <div className="space-y-2">
                  <div className="w-14 h-3 rounded bg-gray-200 dark:bg-neutral-700 animate-pulse"></div>
                  <div className="w-20 h-4 rounded bg-gray-200 dark:bg-neutral-700 animate-pulse"></div>
                </div>
                <div className="space-y-2">
                  <div className="w-14 h-3 rounded bg-gray-200 dark:bg-neutral-700 animate-pulse"></div>
                  <div className="w-20 h-4 rounded bg-gray-200 dark:bg-neutral-700 animate-pulse"></div>
                </div>
                <div className="space-y-2">
                  <div className="w-14 h-3 rounded bg-gray-200 dark:bg-neutral-700 animate-pulse"></div>
                  <div className="w-20 h-4 rounded bg-gray-200 dark:bg-neutral-700 animate-pulse"></div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="h-8 w-48 rounded bg-gray-200 dark:bg-neutral-700 animate-pulse mb-4"></div>
      {/* Charts Section */}
      <div className="p-4 rounded-lg border border-gray-200 dark:border-neutral-700">
        <div className="h-8 w-24 rounded bg-gray-200 dark:bg-neutral-700 animate-pulse mb-4"></div>
        <div className="h-80 rounded bg-gray-200 dark:bg-neutral-700 animate-pulse"></div>
      </div>
    </div>
  );
};

export default DashboardSkeleton;
